module.exports = __webpack_public_path__ + "static/media/clinician-balancing-preview.9c480e27.svg";